export default {
 base_url:'https://joybookshopapi.akkuratetechnologies.com',
};